import { useNavigate as useReactRouterNavigate } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Пользовательский хук для навигации, который гарантирует что URL всегда содержит параметры
 */
export const useCustomNavigate = () => {
  const navigate = useReactRouterNavigate();
  
  // Константа для предотвращения бесконечных редиректов
  let isRedirecting = false;
  
  // Создаем обертку для функции navigate
  const customNavigate = useCallback((path: string, options?: any) => {
    // Защита от бесконечной рекурсии
    if (isRedirecting) {
      console.log('[Navigation] Предотвращение повторного редиректа');
      return;
    }
    
    // Базовый URL для абсолютных путей
    const baseUrl = window.location.origin;
    
    // Проверяем, является ли путь абсолютным URL
    if (path.startsWith('http://') || path.startsWith('https://')) {
      // Для внешних URL просто выполняем переход
      window.location.href = path;
      return;
    }
    
    // Удаляем baseUrl, если он присутствует в начале пути
    if (path.startsWith(baseUrl)) {
      path = path.substring(baseUrl.length);
    }
    
    // Проверяем, содержит ли путь параметры
    if (
      // Проверка на прямые пути без параметров
      path === '/knowledge' || 
      path === '/chat' || 
      path === '/studio' || 
      path === '/dashboard' ||
      path.startsWith('/articles/') && !path.includes('/', 10) ||
      path === '/roadmap'
    ) {
      // Если URL не содержит параметров, добавляем их
      const timestamp = Date.now();
      isRedirecting = true;
      
      try {
        if (path === '/knowledge') {
          navigate('/knowledge/root', options);
        } else if (path === '/chat') {
          navigate(`/chat/default-${timestamp}`, options);
        } else if (path === '/studio' || path === '/dashboard') {
          navigate('/studio', options);
        } else if (path === '/roadmap') {
          navigate('/roadmap', options);

        } else if (path.startsWith('/articles/')) {
          // Специальная обработка для страницы reel
          if (path === '/articles/reels') {
            navigate('/reels', options);
          } else {
            // Для статей добавляем параметр с ID
            const basePath = path;
            navigate(`${basePath}/new-${timestamp}`, options);
          }
        }
        
        console.log(`[Navigation] Перенаправление: ${path} -> с параметрами`);
      } finally {
        // Сбрасываем флаг редиректа
        setTimeout(() => {
          isRedirecting = false;
        }, 100);
      }
      return;
    }
    
    // Если путь уже содержит параметры или это специальный путь, выполняем обычную навигацию
    navigate(path, options);
  }, [navigate]);
  
  return customNavigate;
}; 